export const VOLT_TILE_TEST_ID = 'volt-tile';
export const CART_TILE_TEST_ID = 'cart-tile';
